import { useState, useEffect } from "react";
import Board from "./Board";
import Score from "./Score";
import useKeyboard from "../hooks/useKeyboard";
import {
  initBoard,
  moveBoard,
  addRandomTile,
  isGameOver,
} from "../utils/gameLogic.js";

const Game = () => {
  const [board, setBoard] = useState(() => addRandomTile(addRandomTile(initBoard())));
  const [score, setScore] = useState(0);

  const handleMove = (direction) => {
    const result = moveBoard(board, direction);

    if (!result.moved) return;

    const newBoard = addRandomTile(result.board);
    setBoard(newBoard);
    setScore((prev) => prev + result.score);
  };

  useKeyboard(handleMove);

  useEffect(() => {
    if (isGameOver(board)) {
      alert("Game Over!");
    }
  }, [board]);

  return (
    <div className="game">
      <h1>2048</h1>
      <Score score={score} />
      <Board board={board} />
      <button
        onClick={() => {
          setBoard(addRandomTile(addRandomTile(initBoard())));
          setScore(0);
        }}
      >
        Restart
      </button>
    </div>
  );
};

export default Game;
